var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNewrelic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 832.8 959.8",
    xmlns: "http://www.w3.org/2000/svg",
    width: 2169,
    height: 2500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M672.6 332.3l160.2-92.4v480L416.4 959.8V775.2l256.2-147.6z",
    fill: "#00ac69"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M416.4 184.6L160.2 332.3 0 239.9 416.4 0l416.4 239.9-160.2 92.4z",
    fill: "#1ce783"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M256.2 572.3L0 424.6V239.9l416.4 240v479.9l-160.2-92.2z",
    fill: "#1d252c"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewrelic);
export default __webpack_public_path__ + "97120/static/media/newrelic.d573ab16a2f658399c78cda40f8b1681.svg";
export { ForwardRef as ReactComponent };